module.exports = __webpack_public_path__ + "img/Frame 1099four1.9fbaa460.png";